import { ChangeDetectionStrategy, Component, inject, signal, Type } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter, startWith, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'shared-core-header-left-slot-outlet',
  template: `<ng-container *ngComponentOutlet="component()" />`,
  imports: [NgComponentOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLeftSlotOutletComponent {
  private readonly router = inject(Router);
  protected readonly component = signal<Type<unknown> | null>(null);

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        startWith(null),
        switchMap(() => this.resolve()),
        takeUntilDestroyed(),
      )
      .subscribe((c) => this.component.set(c));
  }

  private async resolve(): Promise<Type<unknown> | null> {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) route = route.firstChild;
    const factory = route.data['headerLeftSlotComponent'];

    return factory ? await factory() : null;
  }
}
